import { Response, PaginatedResponse } from '..'
import { buildQuery } from '../../helpers'

// GET /api/autotask/roles
// POST /api/autotask/roles/search
export async function getRoles(query = null, options = {}, requestOptions = {}) {
	if (typeof query !== 'object' || query === null) {
		return PaginatedResponse.request('/api/autotask/roles' + buildQuery(options), null, requestOptions)
	}
	return PaginatedResponse.request('/api/autotask/roles/search', Object.assign({ query }, options), requestOptions)
}

// POST /api/autotask/roles
export async function createRole(data, requestOptions = {}) {
	return Response.request('/api/autotask/roles', data, requestOptions)
}

// GET /api/autotask/roles/:id
export async function getRole(id, requestOptions = {}) {
	return Response.request('/api/autotask/roles/' + encodeURIComponent(id), null, requestOptions)
}

// PUT /api/autotask/roles/:id
export async function updateRole(id, data, requestOptions = {}) {
	return Response.request('/api/autotask/roles/' + encodeURIComponent(id), data, Object.assign({ method: 'PUT' }, requestOptions))
}
